import { render, staticRenderFns } from "./approve-node-panel.vue?vue&type=template&id=ff458b18&scoped=true"
import script from "./approve-node-panel.vue?vue&type=script&lang=js"
export * from "./approve-node-panel.vue?vue&type=script&lang=js"
import style0 from "./approve-node-panel.vue?vue&type=style&index=0&id=ff458b18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff458b18",
  null
  
)

export default component.exports